// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__r4ELY","nameInput":"Home_nameInput__34TTO"};